export const REFRESH_DELAY = 4000;
